var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlighter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 47.717,
    viewBox: "0 0 41 47.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "highlighter",
    transform: "translate(-27 -1313.283)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 41,
    height: 12,
    rx: 4,
    transform: "translate(27 1347)",
    fill: "#ffed7f"
  }), /*#__PURE__*/React.createElement("text", {
    id: "abc",
    transform: "translate(46 1357)",
    fill: "#6a6a6a",
    fontSize: 12,
    fontFamily: "Nunito-Regular, Nunito"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "abc")), /*#__PURE__*/React.createElement("g", {
    id: "highlighter-2",
    "data-name": "highlighter",
    transform: "translate(28 1313.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M7.359,167.852c-.421.864-3.21,6.533-1.078,6.522,1.136-.006,2.447-.608,3.555-.7.889-.074,1.42-1.029,1.97-2Z",
    transform: "translate(-4.297 -131.428)",
    fill: "#f0b934",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M23.084,34.679c.525-1.259,8.222-21.961,8.9-25.5.159-.83.811-2.208.436-3.128C31.79,4.507,22.916,0,22.877,0c-.989.054-1.956,1.233-2.637,1.732-.423.31-1.113.911-1.985,1.715C13.149,8.159,1.8,19.824,1.02,20.69A3.6,3.6,0,0,0,0,22.7c-.3,2.831,19.268,15.235,21.7,13.758a3.591,3.591,0,0,0,1.382-1.779",
    transform: "translate(-0.001 -0.001)",
    fill: "#f0b934"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M3.672,111.123c1.7,2.67,2.669,5.6,1.965,8.432-.334,1.342-1.485,2.728-.981,4.135.338.942,5.457,4.24,6.435,4.146,1.459-.142,2.167-1.813,3.209-2.7,2.376-2.019,5.695-2.283,9.042-1.706Z",
    transform: "translate(-2.875 -87.009)",
    fill: "#59595a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M28.007,2.818C25.6,1.265,23.339-.024,22.877,0c-.989.054-1.956,1.233-2.637,1.732-.423.31-1.113.911-1.985,1.715C13.149,8.158,1.8,19.824,1.02,20.69A3.6,3.6,0,0,0,0,22.7c-.153,1.461,4.567,5.207,9.91,8.544Z",
    transform: "translate(0 -0.001)",
    fill: "#ffed7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M13.44,117.23l-9.768-6.107c1.7,2.67,2.669,5.6,1.965,8.432-.334,1.342-1.485,2.728-.981,4.135.189.526,1.452,1.522,3.071,2.517Z",
    transform: "translate(-2.875 -87.009)",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M0,0H32.533V42.946H0Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlighter);
export default __webpack_public_path__ + "static/media/highlighter.445830bbc8a0dfb628af307141180330.svg";
export { ForwardRef as ReactComponent };